import React from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';

const H2 = ({ classNames, ...props }) => (
  <h2 className={cn(styles.h2, classNames, props.styles)} style={props.style}>
    {props.children}
  </h2>
);

export default H2;
